var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "system-config" },
    [
      _c(
        "el-tabs",
        { attrs: { type: "border-card" } },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "积分商城" } },
            [
              _c(
                "el-form",
                {
                  staticClass: "setting-form",
                  attrs: {
                    model: _vm.point,
                    size: "medium",
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "支付方式",
                        prop: "payment.settingValue",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择支付方式" },
                          model: {
                            value: _vm.point.payment.settingValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.point.payment, "settingValue", $$v)
                            },
                            expression: "point.payment.settingValue",
                          },
                        },
                        _vm._l(_vm.paymentMethod, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "最多使用",
                        prop: "maxPoint.settingValue",
                      },
                    },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: {
                            type: "number",
                            placeholder: "请输入最多使用积分数",
                          },
                          model: {
                            value: _vm.point.maxPoint.settingValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.point.maxPoint, "settingValue", $$v)
                            },
                            expression: "point.maxPoint.settingValue",
                          },
                        },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { slot: "prepend" },
                              slot: "prepend",
                              model: {
                                value: _vm.point.maxPoint.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.point.maxPoint, "status", $$v)
                                },
                                expression: "point.maxPoint.status",
                              },
                            },
                            [_vm._v("启用")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "福利商城" } },
            [
              _c(
                "el-form",
                {
                  staticClass: "setting-form",
                  attrs: {
                    model: _vm.welfare,
                    size: "medium",
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "支付方式",
                        prop: "payment.settingValue",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择支付方式" },
                          model: {
                            value: _vm.welfare.payment.settingValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.welfare.payment, "settingValue", $$v)
                            },
                            expression: "welfare.payment.settingValue",
                          },
                        },
                        _vm._l(_vm.paymentMethod, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "热销数量",
                        prop: "hotSale.settingValue",
                      },
                    },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: {
                            type: "number",
                            placeholder: "请输入热销榜单显示的数量",
                          },
                          model: {
                            value: _vm.welfare.hotSale.settingValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.welfare.hotSale, "settingValue", $$v)
                            },
                            expression: "welfare.hotSale.settingValue",
                          },
                        },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { slot: "prepend" },
                              slot: "prepend",
                              model: {
                                value: _vm.welfare.hotSale.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.welfare.hotSale, "status", $$v)
                                },
                                expression: "welfare.hotSale.status",
                              },
                            },
                            [_vm._v("显示")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "上新数量",
                        prop: "newSale.settingValue",
                      },
                    },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: {
                            type: "number",
                            placeholder: "请输入今日上新显示的数量",
                          },
                          model: {
                            value: _vm.welfare.newSale.settingValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.welfare.newSale, "settingValue", $$v)
                            },
                            expression: "welfare.newSale.settingValue",
                          },
                        },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { slot: "prepend" },
                              slot: "prepend",
                              model: {
                                value: _vm.welfare.newSale.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.welfare.newSale, "status", $$v)
                                },
                                expression: "welfare.newSale.status",
                              },
                            },
                            [_vm._v("显示")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "优品商城" } },
            [
              _c(
                "el-form",
                {
                  staticClass: "setting-form",
                  attrs: {
                    model: _vm.superior,
                    size: "medium",
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "支付方式",
                        prop: "payment.settingValue",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择支付方式" },
                          model: {
                            value: _vm.superior.payment.settingValue,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.superior.payment,
                                "settingValue",
                                $$v
                              )
                            },
                            expression: "superior.payment.settingValue",
                          },
                        },
                        _vm._l(_vm.paymentMethod, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "热销数量",
                        prop: "hotSale.settingValue",
                      },
                    },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: {
                            type: "number",
                            placeholder: "请输入热销榜单显示的数量",
                          },
                          model: {
                            value: _vm.superior.hotSale.settingValue,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.superior.hotSale,
                                "settingValue",
                                $$v
                              )
                            },
                            expression: "superior.hotSale.settingValue",
                          },
                        },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { slot: "prepend" },
                              slot: "prepend",
                              model: {
                                value: _vm.superior.hotSale.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.superior.hotSale, "status", $$v)
                                },
                                expression: "superior.hotSale.status",
                              },
                            },
                            [_vm._v("显示")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "上新数量",
                        prop: "newSale.settingValue",
                      },
                    },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: {
                            type: "number",
                            placeholder: "请输入今日上新显示的数量",
                          },
                          model: {
                            value: _vm.superior.newSale.settingValue,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.superior.newSale,
                                "settingValue",
                                $$v
                              )
                            },
                            expression: "superior.newSale.settingValue",
                          },
                        },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { slot: "prepend" },
                              slot: "prepend",
                              model: {
                                value: _vm.superior.newSale.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.superior.newSale, "status", $$v)
                                },
                                expression: "superior.newSale.status",
                              },
                            },
                            [_vm._v("显示")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "网红专栏", prop: "online.settingValue" },
                    },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: {
                            type: "number",
                            placeholder: "请输入网红专栏显示的数量",
                          },
                          model: {
                            value: _vm.superior.online.settingValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.superior.online, "settingValue", $$v)
                            },
                            expression: "superior.online.settingValue",
                          },
                        },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { slot: "prepend" },
                              slot: "prepend",
                              model: {
                                value: _vm.superior.online.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.superior.online, "status", $$v)
                                },
                                expression: "superior.online.status",
                              },
                            },
                            [_vm._v("显示")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "换位时间",
                        prop: "exchange.settingValue",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "number",
                          placeholder: "请输入左右区交换位置时间，单位（天）",
                        },
                        model: {
                          value: _vm.superior.exchange.settingValue,
                          callback: function ($$v) {
                            _vm.$set(_vm.superior.exchange, "settingValue", $$v)
                          },
                          expression: "superior.exchange.settingValue",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "全局配置" } },
            [
              _c(
                "el-form",
                {
                  staticClass: "setting-form",
                  attrs: {
                    model: _vm.global,
                    size: "medium",
                    "label-width": "auto",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "global-payment-setting",
                      attrs: { label: "是否允许购物" },
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.global.payment.settingValue.gift,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.global.payment.settingValue,
                                "gift",
                                $$v
                              )
                            },
                            expression: "global.payment.settingValue.gift",
                          },
                        },
                        [_vm._v("允许购买身份礼包")]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.global.payment.settingValue.earnings,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.global.payment.settingValue,
                                "earnings",
                                $$v
                              )
                            },
                            expression: "global.payment.settingValue.earnings",
                          },
                        },
                        [_vm._v("允许购买收益礼包")]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.global.payment.settingValue.point,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.global.payment.settingValue,
                                "point",
                                $$v
                              )
                            },
                            expression: "global.payment.settingValue.point",
                          },
                        },
                        [_vm._v("允许积分商城购物")]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.global.payment.settingValue.welfare,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.global.payment.settingValue,
                                "welfare",
                                $$v
                              )
                            },
                            expression: "global.payment.settingValue.welfare",
                          },
                        },
                        [_vm._v("允许福利商城购物")]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.global.payment.settingValue.superior,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.global.payment.settingValue,
                                "superior",
                                $$v
                              )
                            },
                            expression: "global.payment.settingValue.superior",
                          },
                        },
                        [_vm._v("允许优品商城购物")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "审核时显示部分内容" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.global.upgrade.settingValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.global.upgrade, "settingValue", $$v)
                            },
                            expression: "global.upgrade.settingValue",
                          },
                        },
                        [_vm._v("允许优品商城购物")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form",
        {
          staticClass: "button-form",
          attrs: { size: "medium", "label-width": "115px" },
        },
        [
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                [_vm._v("提交保存")]
              ),
              _c("el-button", [_vm._v("取消")]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }